/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import { useIntl } from 'react-intl';
import CartItemList from '../CartItemList';
import CartBar from '../CartBar';
import css from './index.module.scss';
import EmptyCart from './EmptyCart';
const { cartItems } = Slices.cartSlice;
const { selectProductEntities } = Slices.productSlice;
import Skeleton from 'react-loading-skeleton';
import RefreshCartValues from './RefreshCartValues';
export default function MiniCart() {
  const productsMap = useSelector(selectProductEntities);
  const cart = useSelector(cartItems);
  const intl = useIntl();
  const cartData = useSelector((state) => state.cart);
  const countOfItems = cart.reduce((a, { qty }) => a + qty, 0);
  const cartItemsList = cart.map(
    (cartItem) => productsMap[cartItem.id] || productsMap[cartItem?.catId]
  );

  const renderContent = () => {
    return countOfItems > 0 ? (
      <React.Fragment>
        <CartItemList
          miniCart={true}
          itemList={cart}
          freeItems={
            cartData.data.freeItems
              ? cartData.data.freeItems[intl.locale.toLowerCase()]?.map((item) => item.id)
              : []
          }
        />
        {/* <ApplyCoupon /> */}
      </React.Fragment>
    ) : (
      <EmptyCart />
    );
  };

  const isLoading = () => {
    return (
      // status === 'loading' ||
      // !productsMap || !Object.keys(productsMap).length || cartItemsList?.includes(undefined)
      // TODO: fix this skelton issue
      false
    );
  };

  return (
    <>
      {/* <RefreshCartValues /> */}
      <div className={css.root}>
        {isLoading() ? (
          <div className={css.wrapper}>
            <div className={css.cartHeading}>
              <Skeleton count={1} className={css.Skeleton} width="100%" height="100%" />
            </div>
            <div className={css.miniCartList}>
              <Skeleton
                count={2}
                className={css.Skeleton}
                width="100%"
                height="100px"
                style={{ marginBottom: '1rem' }}
              />
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div className={css.wrapper}>
              <div className={css.miniCartList}>{renderContent()}</div>
            </div>
            <CartBar miniCart={true} />
          </React.Fragment>
        )}
      </div>
    </>
  );
}
